const work = [
    {
        company: "Optum",
        client: "Optum",
        project: "Aikyam",
        role: "Fullstack Engineer",
        description: `The Role-Based Access Control (RBAC) application provides a secure and flexible method for managing user access within a system. By defining user roles and associating specific permissions with those roles, the system ensures that only authorized users can access sensitive or restricted data and perform certain actions. This project aims to implement a robust role-based authorization mechanism that can be easily integrated into various platforms..`,
        responsibilities: `Worked on complete development of GraphQL Api’s, involved in Design / Architecture sessions, optimized and improved the readability of the existing code. Introduced GitHub CoPilot to the team and created the test cases automatically which reduced development time. Added CoPilot review which saves peer review time.`,
        technologies: ['Java', 'Springboot', 'GraphQL', 'My Sql', 'GitHubCopilot', 'CodeQlAutofix'],
        paths: [
          {
            path: 'optum.png', 
            alt: 'Optum'
          },
          {
            path: 'optum.png', 
            alt: 'Optum'
          }],
        tenure: '2024 - Current',
        id: 1
      },
    {
        company: "Optum",
        client: "Rally",
        project: "Coaching",
        role: "Fullstack Engineer",
        description: `Single platform which offers a variety of programs to improve health like Quit Tobacco, Living with Diabetes, Hypertension, Eat well, RealAppeal, RealAppeal Rx. Quit For Life program helps people to quit tobacco for good. It helps people to take surveys of their current habits and recommends and ships medicines. It also offers one-on-one coaching via live video chat with coaches. Our product Quit for Life has helped over 5M+ users to quit tobacco. Real Appeal Rx program has the primary goal of helping patients with 30+ BMI reduce weight by offering intensive lifestyle interventions tailored for patients taking GLP-1 medication. Equip with tools to make lifestyle changes to have a control on their weight loss journey. Offering Coaches with guidance, group sessions, Med Adherence tracker, Food tracker..`,
        responsibilities: `Worked on programs Q4l and Real Appeal Rx, developed individual modules from Frontend to Backend using Angular for customer end Application and React for Admin application, Scala and play framework for REST services and PostgreSQL for DB. Lead the RaRx team in complete development from Onshore, took PR Review’s for Onshore, Conducted review / feedback sessions from team.`,
        technologies: ['React', 'Scala', 'Angular', 'Angular Material', 'Javascript'],
        paths: [
          {
            path: 'optum.png', 
            alt: 'Optum'
          },
          {
            path: 'optum.png', 
            alt: 'Optum'
          }],
        tenure: '2022 - 2024',
        id: 2
      },
      {
        company: "Oracle",
        client: "Oracle",
        project: "Oracle Utilities Application Framework",
        role: "Fullstack Engineer",
        description: `Thrive in a sustainable, affordable energy and water future. Deliver outstanding customer experiences, improve energy efficiency, and manage networks and assets so you can deliver essential services to your communities every day. This brings industry leading. meter data management, customer care, and billing capabilities into a single, unified solution that supports modern utilities’ customer care operations.`,
        responsibilities: `Re-writing the complete application from scratch. Developing large scale and mid-level Web components which replaces old code. Need to convert into Angular. Lead 3 Associate engineers from OnShore.`,
        technologies: ['Java', 'Springboot', 'My Sql', 'Angular', 'Ojet Library'],
        paths: [
          {
            path: 'oracle.png', 
            alt: 'Optum'
          },
          {
            path: 'oracle.png', 
            alt: 'Optum'
          }],
        tenure: '2020 - 2022',
        id: 3
      },
      {
      company: "HCL Technologies",
      client: "Google",
      project: "Athena",
      role: "Software Engineer",
      description: `PARC (​Pitching And Reporting Collateral) Google Ads is an online
                   advertising platform developed by Google, where advertisers pay to 
                   display brief advertisements, service offerings, product listings, 
                   video content, and generate mobile application installs within the 
                   Google ad network to web users.`,
      responsibilities: `Responsible for complete Frontend development of the application includes various module development.`,
      technologies: ['Angular', 'Angular Material', 'Javascript', 'HTML', 'CSS3', 'GoogleSQL', 'Appscript'],
      paths: [
        {
          path: 'hcl.png', 
          alt: 'HCL'
        },
        {
          path: 'google.png', 
          alt: 'Google'
        }],
      tenure: '2018 - 2020',
      id: 4
    },
    {
      company: "HCL Technologies",
      client: "Google",
      projects: "Slate",
      role: "Frontend Engineer",
      description: `Slate is reporting platform similar to Athena.
                    You can generate a report with all the opportunities 
                    or just the opportunities that you are interested in. 
                    DBMCM is a double click bid management, mainly used for 
                    ad management.`,    
      responsibilities: `Responsible for complete Frontend development of the application includes various module development.`,
      technologies: ['Angular', 'Kennedy UI', 'Javascript', 'HTML', 'CSS3'],
      paths: [
        {
          path: 'hcl.png', 
          alt: 'HCL'
        },
        {
          path: 'google.png', 
          alt: 'Google'
        }],
      
      tenure: '2016 - 2018',
      id: 5
    },
    {
      company: "V3 Staffing",
      client: "Google",
      projects: "DBMCM",
      role: "Frontend Engineer",
      description: `DBMCM is a double click bid management, mainly used for
                    ad management. The features include listing various advertisers, 
                    creating a goal on how ad should perform and tracking goal. 
                    Analysis of whether goal is underperforming or performing well.`,
      responsibilities: `Responsible for complete Frontend development of the application includes various module development.`,
      technologies: ['Angular 1.x', 'Angular Material', 'Javascript', 'HTML', 'CSS3'],
      paths: [
        {
          path: 'v3.png', 
          alt: 'V3 Staffing'
        },
        {
          path: 'google.png', 
          alt: 'Google'
      }],
      tenure: '2015 - 2015',
      id: 6
    },
    {
      company: "V3 Staffing",
      client: "Google",
      projects: "Shoppanizer",
      role: "Frontend Engineer",
      description: `Shoppanizer is a double click bid management, mainly used for
                    ad management. The features include listing various advertisers, 
                    creating a goal on how ad should perform and tracking goal. 
                    Analysis of whether goal is underperforming or performing well.`,
      responsibilities: `Responsible for complete Frontend development of the application includes various module development.`,
      technologies: ['Angular 1.x', 'Angular Material', 'Javascript', 'HTML', 'CSS3'],
      paths: [
        {
          path: 'v3.png', 
          alt: 'V3 Staffing'
        },
        {
          path: 'google.png', 
          alt: 'Google'
      }],
      tenure: '2015 - 2015',
      id: 7
    },
    {
      company: "Aspire",
      client: "Cognizant",
      projects: "Abbvie",
      role: "Frontend Engineer",
      description: `Development of web site for Abbvie using Veeva tool same as
                    the Exploria here the tool differs.This application is a health portal. It shows users various
                    kinds of diseases, their effects, symptoms and prevention.`,
      responsibilities: `Responsible for complete Frontend development of the application which include website development`,
      technologies: ['jQuery', 'Bootstrap', 'HTML', 'CSS3'],
      paths: [
        {
          path: 'aspire.png', 
          alt: 'Aspire Info'
        },
        {
          path: 'cognizant.png', 
          alt: 'Cognizant'
      }],
      tenure: '2014 - 2015',
      id: 8
    }
  ];
  
  export default work;
  
